export function flatDeep<T>(arr: any[], d = 9): T[] {
    return d > 0
        ? arr.reduce(
              (acc, val) =>
                  acc.concat(
                      Array.isArray(val) ? flatDeep(val, d - 1) : val
                  ),
              []
          )
        : arr.slice();
}
